(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    /* BD20 - relabel size option "Størrelse" -> "Size" (display only) */
  (function(){
    function relabel(){
      var els = document.querySelectorAll('.variant-option legend, .variant-option label');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var nodes = el.childNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType === 3 && n.nodeValue.trim().toLowerCase() === 'størrelse') {
            n.nodeValue = n.nodeValue.replace(/størrelse/i, 'Size');
          }
        }
      }
    }
    relabel();
    document.addEventListener('DOMContentLoaded', relabel);
    window.addEventListener('load', relabel);
    var bd20RelabelTarget = document.querySelector('.product-details') || document.body;
    if(bd20RelabelTarget && window.MutationObserver){
      new MutationObserver(function(){ relabel(); }).observe(bd20RelabelTarget, { childList: true, subtree: true });
    }
  })();

  (function(){
    var mq = window.matchMedia('(max-width:749px)');
    function init(){
      if(!mq.matches) return;
      var fs = document.querySelector('.variant-option--buttons');
      if(!fs || fs.querySelector('.bd20-size-toggle')) return;
      var legend = fs.querySelector('legend');
      var label = legend ? legend.textContent.trim() : 'Size';
      if(label.toLowerCase() === 'størrelse') label = 'Size';
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bd20-size-toggle';
      toggle.innerHTML = '<span class="bd20-size-toggle__label"></span><span class="bd20-size-toggle__val"></span><svg class="bd20-size-toggle__caret" width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><polyline points="3 5 7 9 11 5"/></svg>';
      toggle.querySelector('.bd20-size-toggle__label').textContent = label;
      fs.insertBefore(toggle, legend ? legend.nextSibling : fs.firstChild);
      var val = toggle.querySelector('.bd20-size-toggle__val');
      function upd(){ var c = fs.querySelector('input:checked'); val.textContent = c ? c.value : 'Select'; }
      upd();
      toggle.addEventListener('click', function(){ fs.classList.toggle('bd20-size-open'); });
      fs.addEventListener('change', function(){ upd(); fs.classList.remove('bd20-size-open'); });
    }
    document.addEventListener('click', function(e){
      var openFs = document.querySelector('.variant-option--buttons.bd20-size-open');
      if(openFs && !openFs.contains(e.target)) openFs.classList.remove('bd20-size-open');
    });
    document.addEventListener('DOMContentLoaded', init);
    init();
    if(mq.addEventListener){ mq.addEventListener('change', init); }
    /* Rebuild the dropdown after Shopify re-renders the variant picker on variant change */
    var bd20SizeTarget = document.querySelector('.product-details') || document.body;
    if(bd20SizeTarget && window.MutationObserver){
      new MutationObserver(function(){ init(); }).observe(bd20SizeTarget, { childList: true, subtree: true });
    }
  })();

  /* BD20 - Fabric Details + Shipping & Returns accordion toggles */
  (function(){
    ['[data-bd20-fabric]', '[data-bd20-sr]'].forEach(function(sel){
      var el = document.querySelector('.bd20-pinfo' + sel);
      if(!el) return;
      var head = el.querySelector('.bd20-pinfo__head');
      var body = el.querySelector('.bd20-pinfo__body');
      if(!head || !body) return;
      head.addEventListener('click', function(){
        var open = el.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
      });
    });
  })();

  /* BD20 - relocate Product Info + Fabric Details + Shipping & Returns directly below the Add to Cart button (works on mobile + desktop) */
  (function(){
    function place(){
      var details = document.querySelector('.template-product .product-details') || document.querySelector('.product-details');
      if(!details) return;
      /* Use the in-flow add-to-cart, never the sticky/pinned one */
      var cands = details.querySelectorAll('add-to-cart-component, .buy-buttons-block');
      var bb = null;
      for(var k = 0; k < cands.length; k++){
        if(!cands[k].closest('sticky-add-to-cart, .sticky-add-to-cart, .sticky-add-to-cart__bar')){ bb = cands[k]; break; }
      }
      if(!bb){ bb = cands[0]; }
      if(!bb) return;
      var anchor = bb.closest('.buy-buttons-block, add-to-cart-component, .group-block') || bb;
      var ref = anchor;
      var order = ['[data-bd20-pinfo]', '[data-bd20-fabric]', '[data-bd20-sr]'];
      for(var i = 0; i < order.length; i++){
        var el = document.querySelector('.bd20-pinfo' + order[i]);
        if(!el || !ref.parentNode) continue;
        /* idempotent: only move if not already the next sibling of ref */
        if(!(el.parentNode === ref.parentNode && ref.nextElementSibling === el)){
          if(ref.nextSibling){ ref.parentNode.insertBefore(el, ref.nextSibling); }
          else { ref.parentNode.appendChild(el); }
        }
        ref = el;
      }
      /* Hide stray empty leftover boxes anywhere in the product details (no text, no media/controls) */
      var bd20Boxes = details.querySelectorAll('div, fieldset, section');
      for(var b = 0; b < bd20Boxes.length; b++){
        var bnode = bd20Boxes[b];
        var bcl = bnode.classList;
        if(bcl && (bcl.contains('bd20-pinfo') || bcl.contains('bd20-pinfo__head') || bcl.contains('bd20-pinfo__body') || bcl.contains('bd20-pinfo__content') || bcl.contains('visually-hidden'))) continue;
        if(bnode.getAttribute('aria-live')) continue;
        if((bnode.textContent || '').replace(/\s+/g, '') !== '') continue;
        if(bnode.querySelector('img, svg, button, input, select, textarea, a, video, iframe, canvas, picture')) continue;
        bnode.style.display = 'none';
      }
    }
    document.addEventListener('DOMContentLoaded', place);
    window.addEventListener('load', place);
    setTimeout(place, 500);
    var bd20RelTarget = document.querySelector('.product-details') || document.body;
    if(bd20RelTarget && window.MutationObserver){
      new MutationObserver(function(){ place(); }).observe(bd20RelTarget, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
